import * as coreAxios from 'axios';
import config from '../config/config';
import { ServerAlertAction } from '../components/common/types/ServerAlertAction';

const axios = coreAxios.default.create({
  baseURL: config.baseURL
});

//no toast
export const axiosNT = coreAxios.default.create({
  baseURL: config.baseURL
});

export const axiosUpload = coreAxios.default.create({
  baseURL: ''
});

//no global loader
export const axiosNL = coreAxios.default.create({
  baseURL: config.baseURL
});

//no global loader and toast
export const axiosNTL = coreAxios.default.create({
  baseURL: config.baseURL
});

// no success message
export const axiosNS = coreAxios.default.create({
  baseURL: config.baseURL
})

export const watsonAxios = coreAxios.default.create({
  baseURL: config.watsonURL
});

export const singleUserAxios = coreAxios.default.create({
  baseURL: config.stakeholderAPIurl
});

export const reCaptchaKey = coreAxios.default.create({
  baseURL: config.captchaKey
});



export default axios;